var map = {
	"./Familia.png": 3545,
	"./Intelectual.png": 4617,
	"./Mecanismo.png": 1108,
	"./Migratorio.png": 6142,
	"./Negocios.png": 1016,
	"./Privado.png": 7011,
	"./Responsabilidad.png": 1408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3253;